import AuthUtils from '@utils/AuthUtils'
import axios, { InternalAxiosRequestConfig } from 'axios'
import qs from 'qs'

const api = axios.create({
	baseURL: import.meta.env.VITE_DMW_BASE_URL,
	withCredentials: false,
	timeout: 60000,
	headers: {
		'Content-Type': 'application/json',
	},
	// Allow arrays to be properly serialized in query params for GET requests
	paramsSerializer: (params) => qs.stringify(params, { allowDots: true, skipNulls: true }),
})

// const setAuthHeader = (token: string) => {
// api.defaults.headers.common.Authorization = `Bearer ${AuthUtils.getSsoToken()}`
// }

// if (AuthUtils.getSsoToken()) {
// 	setAuthHeader(AuthUtils.getSsoToken())
// }

// Retrieve token before each request, first request after sign in fails if Authorization set directly
api.interceptors.request.use(
	(config) => {
		const token = AuthUtils.getSsoToken()
		if (token) {
			const newConfig = {
				...config,
				headers: { ...config.headers, Authorization: `Bearer ${token}` },
			} as InternalAxiosRequestConfig
			return newConfig
		}
		return config
	},
	(error) => Promise.reject(error)
)

// Handle any server/vpn errors
api.interceptors.response.use(
	(response) => response,
	(error) => {
		if (error.code === 'ERR_NETWORK' && error.message.includes('Network Error')) {
			throw new Error('VPN')
		}
		return Promise.reject(error)
	}
)

// // If 401 error, refresh tokens in localStorage and retry request with new tokens
api.interceptors.response.use(
	(response) => response,
	async (error) => {
		try {
			if (!error.response) await Promise.reject(error)
			// 440 is thrown when the token is expired
			// if (error.response.status === 401 || error.response.status === 440) {
			// 	const originalReqConfig = error.config
			// 	// get SSO token
			// 	const request = {
			// 		scopes: ['User.Read'],
			// 		account: AuthUtils.getSsoAccount(),
			// 	}
			// 	const response = await window.msalInstance.acquireTokenSilent(request)
			// 	AuthUtils.setSsoToken(response.accessToken)
			// 	let accessToken = null
			// 	const { accessToken: token, success } = await AuthUtils.refreshBepToken()

			// 	if (success) accessToken = token

			// 	if (!success) {
			// 		// try to login again
			// 		try {
			// 			await AuthUtils.bepLogin()
			// 			const { accessToken: token } = await AuthUtils.refreshBepToken()
			// 			accessToken = token
			// 		} catch (error) {
			// 			console.error('Error logging into BEP: ', error)
			// 			throw new Error(error)
			// 		}
			// 	}

			// 	// Update axios Authorization header and reattempt original request
			// 	if (accessToken) {
			// 		setAuthHeader(accessToken)
			// 		originalReqConfig.headers.Authorization = `Bearer ${accessToken}`
			// 		return await api(originalReqConfig)
			// 	}
			// }

			// FIXME: We may need to add a catch for the refresh token expiring
			if (error) {
				return await Promise.reject(error)
			}
		} catch (refreshTokensError) {
			return Promise.reject(refreshTokensError)
		}
	}
)

export default api
